import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  button: {
    backgroundColor: '#FFF',
    borderRadius: 'none',
    borderRight: '1px solid #E8E8E8 !important',
    color: '#4A4A4A',
    fontSize: 15,
    fontWeight: 'normal',
    width: 165,
    height: '44px !important',
    '&:hover': {
      backgroundColor: '#2D91E9',
      color: '#FFF',
      borderRight: '1px solid #E8E8E8 !important'
    },
    '@media(max-width: 560px)': {
      fontSize: 14,
      width: 'auto',
      padding: '4px 1.75em',
      height: '38px !important',
      '&:hover': {
        height: '38px !important',
      }
    },
  },
  selected: {
    backgroundColor: '#2D91E9',
    color: '#FFF'
  },

});
